import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';
import './Analytics.scss';

export default function MetricBarChart({
    data,
    height = 280,
    emptyText = 'Нет данных за период',
    onBarClick,
    limit = 15,
}) {
    const chartData = (data || []).slice(0, limit);

    if (chartData.length === 0) {
        return <p className="analytics-chart__empty">{emptyText}</p>;
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border-subtle)" />
                <XAxis
                    dataKey="label"
                    tick={{ fontSize: 10 }}
                    interval={0}
                    angle={-25}
                    textAnchor="end"
                    height={72}
                />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip
                    formatter={(value) => [value, 'Событий']}
                    labelFormatter={(label) => label}
                />
                <Bar
                    dataKey="count"
                    fill="var(--color-accent)"
                    radius={[4, 4, 0, 0]}
                    cursor={onBarClick ? 'pointer' : undefined}
                    onClick={onBarClick ? (entry) => onBarClick(entry?.payload || entry) : undefined}
                />
            </BarChart>
        </ResponsiveContainer>
    );
}
